import { render, staticRenderFns } from "./tab3.vue?vue&type=template&id=0e38c810&scoped=true"
import script from "./tab3.vue?vue&type=script&lang=js"
export * from "./tab3.vue?vue&type=script&lang=js"
import style0 from "./tab3.vue?vue&type=style&index=0&id=0e38c810&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e38c810",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e38c810')) {
      api.createRecord('0e38c810', component.options)
    } else {
      api.reload('0e38c810', component.options)
    }
    module.hot.accept("./tab3.vue?vue&type=template&id=0e38c810&scoped=true", function () {
      api.rerender('0e38c810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/require/components/tab3.vue"
export default component.exports